/* eslint-disable max-len */
import React, { useState } from 'react';
import AuctionHeader from './auctionHeader';
import { useNavigate } from 'react-router-dom';

const ChooseType = () => {
    const [auctionOptions, setAuctionOptions] = useState([
        {
            id: 'timed',
            title: 'Timed Auction',
            icon: '/images/timedIcon.svg',
            description: <>An <span className="font-bold">online auction</span> with a countdown timer where bidders place maximum bids. Any bid placed in the final minute will automatically extend the timer. Also known as a silent auction.</>,
            isSelected: false,
            isExpanded: true
        },
        {
            id: 'live',
            title: 'Live Auction',
            icon: '/images/liveIcon.svg',
            description: <>An <span className="font-bold">auction led by an auctioneer</span>, with real-time bids accepted from the room and/or via livestream. Telephone and absentee bids may also be submitted in advance.</>,
            isSelected: false,
            isExpanded: true
        }
    ]);
    const [isBanner, setIsBanner] = useState(true);
    const Navigate = useNavigate();

    const toggleExpanded = (id) => {
        setAuctionOptions(prev => 
            prev.map(option => 
                option.id === id 
                    ? { ...option, isExpanded: !option.isExpanded }
                    : option
            )
        );
    };

    return (
        <>
            <AuctionHeader isBanner={isBanner} setIsBanner={setIsBanner} />
            <div className="min-h-[calc(100vh-68px)] bg-[#F4F4F5] sm:p-6 px-[55px]">
                <div className="max-w-4xl mx-auto py-[120px]">
                    {/* Main Content */}
                    <div className="text-center mb-12">
                        <h2 className="text-2xl font-semibold text-[#343434] mb-2">
                            What type of auction would you like?
                        </h2>
                    </div>

                    <div className="sm:flex items-start justify-center gap-8 max-w-2xl mx-auto">
                        {/* Auction Option */}
                        {auctionOptions.map((type, index)=><><div key={index} className="flex-1 max-w-xs mx-auto">
                            <div className="bg-white shadow-lg rounded-lg p-6 
                                transition-colors">
                                <div 
                                    className="flex items-center justify-between cursor-pointer mb-4"
                                    onClick={() => toggleExpanded(type.id)}>
                                    
                                    <img src={type.icon} />
                                    <div className="text-[#000000] text-[16px] font-medium" data-testid={`${type.title}`}>{type.title}</div>
                                    <div className="text-gray-500">
                                        {type.isExpanded ? 
                                            <img src="/images/auction-hide-dropdown.svg" /> : 
                                            <img src="/images/auction-show-dropdown.svg" />
                                        }
                                    </div>
                                </div>

                                {type.isExpanded && (
                                    <div className="mb-4">
                                        <p className="text-[12px] text-[#000000] leading-relaxed">
                                            {type.description}
                                        </p>
                                    </div>
                                )}

                                <button
                                    onClick={() => Navigate(`/auctions/${type.id}/create`)}
                                    data-testid={`select-${type.id}`}
                                    className={`w-full py-3 px-4 rounded-md font-medium transition-colors bg-[#282828] text-white hover:bg-gray-700`}
                                >
                                    Select
                                </button>
                            </div>
                        </div>{index < auctionOptions.length - 1 && (
                            <div className="flex items-center justify-center py-8 text-[#000000] font-medium sm:text-[34px] text-[20px]">or
                            </div>
                        )}
                        </>)}
                           
                    </div>
                </div>
            </div>
        </>
    );
};

export default ChooseType;